import { render, staticRenderFns } from "./CommercialClaim.vue?vue&type=template&id=5a3683c4&scoped=true&"
import script from "./CommercialClaim.vue?vue&type=script&lang=js&"
export * from "./CommercialClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3683c4",
  null
  
)

export default component.exports